export const state = {
  isInitial: true,
  isLoadingGlobal: true,
  isAttachDelivery: false,
  loadingStartTime: null,

  selectedDos: [],
  sequence: [],
  fleetTaskStatus: '',
  fleetTaskDetail: null,
  importResult: null,
  transitAllState: false,
  transitItems: {},
  transitAddress: null,
  hasDoTransitError: false, // Add this new state property
  selectedFOTransfer: null,
}

export const mutations = {
  SET_ISINITIAL(state, payload) {
    state.isInitial = payload
  },
  SET_ISLOADINGGLOBAL(state, payload) {
    state.isLoadingGlobal = payload
  },
  SET_ISATTACHDELIVERY(state, payload) {
    state.isAttachDelivery = payload
  },
  SET_LOADINGSTARTTIME(state, payload) {
    state.loadingStartTime = payload
  },
  SET_DOS(state, payload) {
    state.selectedDos = payload
  },
  SET_SEQUENCE(state, payload) {
    state.sequence = payload
  },
  SET_FLEETTASKSTATUS(state, payload) {
    state.fleetTaskStatus = payload
  },
  SET_FLEETTASKSTATUSDETAIL(state, payload) {
    state.fleetTaskDetail = payload
  },
  SET_IMPORTRESULT(state, payload) {
    state.importResult = payload
  },

  SET_TRANSIT_ALL_STATE(state, payload) {
    state.transitAllState = payload
  },
  SET_TRANSIT_ITEM(state, { itemId, value }) {
    state.transitItems = { ...state.transitItems, [itemId]: value }
  },
  SET_TRANSIT_ITEMS(state, payload) {
    state.transitItems = payload
  },
  SET_TRANSIT_ADDRESS(state, payload) {
    state.transitAddress = payload
  },
  SET_HAS_DO_TRANSIT_ERROR(state, payload) {
    state.hasDoTransitError = payload
  },
  SET_SELECTED_FO_TRANSFER(state, payload) {
    state.selectedFOTransfer = payload
  },

  RESET_ALLSTATE(state) {
    state.isInitial = true
    state.isLoadingGlobal = true
    state.isAttachDelivery = false
    state.loadingStartTime = null

    state.selectedDos = []
    state.sequence = []
    state.fleetTaskStatus = ''
    state.fleetTaskDetail = null
    state.importResult = null

    state.transitAllState = false
    state.transitItems = {}
    state.transitAddress = null
    state.hasDoTransitError = false // Reset this state as well
    state.selectedFOTransfer = null
  },
}

export const actions = {
  setIsLoadingGlobal({ commit }, payload) {
    commit('SET_ISLOADINGGLOBAL', payload)
  },
  async setIsLoadingGlobalDelay({ commit, state }, payload) {
    if (payload) {
      commit('SET_LOADINGSTARTTIME', Date.now())
      commit('SET_ISLOADINGGLOBAL', true)
    } else {
      const elapsedTime = Date.now() - state.loadingStartTime
      const minDuration = 1000
      if (elapsedTime < minDuration) {
        await new Promise((resolve) => setTimeout(resolve, minDuration - elapsedTime))
      }

      commit('SET_ISLOADINGGLOBAL', false)
    }
  },

  setIsInitial({ commit }, payload) {
    commit('SET_ISINITIAL', payload)
  },

  setIsAttachDelivery({ commit }, payload) {
    commit('SET_ISATTACHDELIVERY', payload)
  },

  setLoadingStartTime({ commit }, payload) {
    commit('SET_LOADINGSTARTTIME', payload)
  },

  setSelectedDos({ commit }, payload) {
    commit('SET_DOS', payload)
  },

  setSequence({ commit }, payload) {
    commit('SET_SEQUENCE', payload)
  },

  setFleetTaskStatus({ commit }, payload) {
    commit('SET_FLEETTASKSTATUS', payload)
  },

  setFleetTaskDetail({ commit }, payload) {
    commit('SET_FLEETTASKSTATUSDETAIL', payload)
  },

  setImportResult({ commit }, payload) {
    commit('SET_IMPORTRESULT', payload)
  },

  setTransitAllState({ commit }, payload) {
    commit('SET_TRANSIT_ALL_STATE', payload)
  },

  setTransitItem({ commit }, { itemId, value }) {
    commit('SET_TRANSIT_ITEM', { itemId, value })
  },

  setTransitItems({ commit }, payload) {
    commit('SET_TRANSIT_ITEMS', payload)
  },

  setTransitAddress({ commit }, payload) {
    commit('SET_TRANSIT_ADDRESS', payload)
  },

  setHasDoTransitError({ commit }, payload) {
    if (payload === true) {
      // Reset dulu ke false
      commit('SET_HAS_DO_TRANSIT_ERROR', false)
      // Kemudian set ke true pada tick berikutnya
      setTimeout(() => {
        commit('SET_HAS_DO_TRANSIT_ERROR', true)
      }, 0)
    } else {
      commit('SET_HAS_DO_TRANSIT_ERROR', payload)
    }
  },

  setSelectedFOTransfer({ commit }, payload) {
    commit('SET_SELECTED_FO_TRANSFER', payload)
  },

  resetAllState({ commit }) {
    commit('RESET_ALLSTATE')
  },
}

export const getters = {
  getTransitAllState: (state) => state.transitAllState,
  getTransitItems: (state) => state.transitItems,
  getTransitItem: (state) => (itemId) => state.transitItems[itemId] || state.transitAllState,
  getHasDoTransitError: (state) => state.hasDoTransitError,
  getSelectedFOTransfer: (state) => state.selectedFOTransfer,
}
